import { Block, Link } from '@xprog/prensa'
import ClickableAsset from 'components/ClickableAsset/ClickableAsset.index'
import Icon from 'components/Icon/Icon.index'
import { useIcon } from 'hooks/useIcon'
import { AssetsContext } from 'providers/Assets'
import React, { useContext } from 'react'

import { SideMenuSectionFooterProps } from './props'

export const SideMenuSectionFooter: React.FC<SideMenuSectionFooterProps> = ({ config }) => {
  const { enabled, advertiseSection, socialmediasSection } = config
  const assetsContext = useContext(AssetsContext)
  const banners = assetsContext?.assets?.banners
  const bannerAnuncie = banners.find((i) => i.name === 'BannerAnuncie')
  const icons = useIcon(socialmediasSection.content.map((i) => i.icon))

  if (!enabled) {
    return null
  }

  return (
    <Block
      css={{
        align: ['column', 'center', 'top'],
        pt: '$10',
        height: '100%'
      }}
    >
      {socialmediasSection.enabled && 
        <Block
          css={{
            align: ['row', 'center', 'middle'],
            backgroundColor: socialmediasSection.color,
            height: '100px',
            width: '100%'
          }}
        >
          {socialmediasSection.content.map((i, k) => (
            <Link
              key={i.id}
              href={i.href}
              target='_blank'
              css={{ height: '33px', m: '$1', ...i.css }}
            >
              <Icon
                alt={icons[k].name}
                src={icons[k].url}
                height={icons[k].height}
                width={icons[k].width}
              />
            </Link>
          ))}
        </Block>
      }
    </Block>
  )
}